import { render, staticRenderFns } from "./otp-verification.vue?vue&type=template&id=2a50da19&scoped=true"
import script from "./otp-verification.vue?vue&type=script&lang=js"
export * from "./otp-verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50da19",
  null
  
)

export default component.exports